// extracted by mini-css-extract-plugin
export var aboutHolder = "About-module--aboutHolder--1rEv7";